// ----------------------------------------------------------------------------
// Snippet: Swatches
// ----------------------------------------------------------------------------
//
// 
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_swatches.scss';